export default {
  main_trans: 'all ease-out 0.25s',
};
